import React, { useState, useEffect } from "react";
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from "recharts";
import { fetch_fii_dii_Data } from "../../ApisService/apiService";
import style from "../../../css/dashboard/Fiidii.module.css";

const FiiDiiData = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch_fii_dii_Data();
                const formattedData = response.map((item) => ({
                    date: new Date(item.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    }),
                    fii_sell: -Math.abs(item.fii_sell),
                    fii_buy: Math.abs(item.fii_buy),
                    dii_sell: -Math.abs(item.dii_sell),
                    dii_buy: Math.abs(item.dii_buy),
                }));
                setData(formattedData);
            } catch (error) {
                console.error("Error fetching FII/DII data:", error);
            }
        };
        fetchData();
    }, []);

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={style.customTooltip} style={{
                    backgroundColor: "rgb(0, 0, 0)",
                    color: "#fff",
                    padding: "12px",
                    borderRadius: "8px",
                    // boxShadow: "0px 4px 10px rgba(212, 212, 212, 0.71)",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "1.5"
                }}>
                    <p style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "8px", borderBottom: "1px solid rgba(255,255,255,0.2)", paddingBottom: "4px" }}>{payload[0].payload.date}</p>
                    {payload.map((entry, index) => (
                        <p key={index} style={{ margin: "4px 0", display: "flex", alignItems: "center" }}>
                            <span style={{
                                display: "inline-block",
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor: entry.color,
                                marginRight: "8px"
                            }}></span>
                            {entry.name}: <strong>{Math.abs(entry.value)}</strong>
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <div className={style.chartContainerfii}>
            <h2 className={style.chartTitle}>FII & DII Buy/Sell Data</h2>
            <ResponsiveContainer width="100%" height={450}>
                <BarChart
                    layout="vertical"
                    data={data}
                    margin={{ top: 20, right: 30, left: 10, bottom: 10 }}
                    barGap={10}
                >
                    <XAxis type="number" hide tickFormatter={(tick) => Math.abs(tick)} />
                    <YAxis dataKey="date" type="category" tick={{ fontSize: 14, fontWeight: "bold" }} axisLine={false} tickLine={false} />
                    <Tooltip 
                        contentStyle={{ backgroundColor: "#fff", borderRadius: "12px", border: "1px solid #ddd", padding: "10px" }}
                        cursor={{ fill: "rgba(200, 200, 200, 0.2)", stroke: "#aaa", strokeWidth: 1, borderRadius: "40px" }}
                        wrapperStyle={{ pointerEvents: "auto" }}
                    />
                    <Legend
                        wrapperStyle={{
                            fontSize: "12px",
                            fontWeight: "600",
                            paddingTop: "10px",
                        }}
                    />
                    <Bar dataKey="fii_sell" fill="#f13744" name="FII Sell" barSize={20} radius={[6, 6, 6, 6]} animationDuration={400} />
                    <Bar dataKey="fii_buy" fill="#059b80" name="FII Buy" barSize={20} radius={[6, 6, 6, 6]} animationDuration={600} />
                    <Bar dataKey="dii_sell" fill="#a10613" name="DII Sell" barSize={20} radius={[6, 6, 6, 6]} animationDuration={800} />
                    <Bar dataKey="dii_buy" fill="#015e4d" name="DII Buy" barSize={20} radius={[6, 6, 6, 6]} animationDuration={1200} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default FiiDiiData;